import React, { useContext } from 'react';
import { ParameterContext } from '../contexts/ParameterContext';

export default function Instructions() {
    const { parameters } = useContext(ParameterContext);

    const getParam = (name) =>
        parameters?.nomParameters?.find(x => x.param_name === name);

    //const privacyLink = getParam('PRIVACY_STATEMENT_LINK')?.value || '/#';
    const showManual = getParam('SHOW_MANUAL_BUTTON')?.value === '1';
    const showQA = getParam('SHOW_QA_BUTTON')?.value === '1';

    const buttons = [
        //{
        //    label: "Декларация за поверителност",
        //    link: privacyLink,
        //    show: true,
        //    icon: (
        //        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        //            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        //        </svg>
        //    ),
        //},
        {
            label: "Ръководство за онлайн регистрация",
            link: "/documents/manuals/manual_parents.pdf",
            show: showManual,
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                </svg>
            ),
        },
        {
            label: "Въпроси и отговори",
            link: "/documents/help/questions.pdf",
            show: showQA,
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
            ),
        },
    ];

    return (
        <>
            <div className="instr-wrapper">
                <div className="title_news instr-title mt-4 mb-5">
                    Указания за ползване на системата
                </div>
                <p className="instr-description">
                    За въпроси и необходимост от методическа помощ за регистрация на заявление, моля,
                    прочетете ръководството или се свържете с директора на училището.
                </p>
                <div className="instr-grid">
                    {buttons.filter(b => b.show).map(({ label, icon, link }) => (
                        <a target="_blank" rel="noreferrer" key={label} href={link} className="instr-btn">
                            <span className="icon-wrap">{icon}</span>
                            <span style={{ fontSize: '1rem' }}>{label}</span>
                        </a>
                    ))}
                </div>
            </div>
        </>
    );
}